export enum CustomerType {
  RFQReceiver = 1,
  RFQSender = 2,
  RFQSenderReceiver = 3,
  B2B = 4,
}
